import React from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import MenuItem from "@material-ui/core/MenuItem";
import { showModal } from "../../../redux/actions";
import AssignAdminUserModal from "./AssignAdminUserModal";

export default ({ circle, onComplete }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const onClick = () => {
    if (onComplete) {
      onComplete();
    }
    dispatch(showModal(AssignAdminUserModal, { circle: circle }));
  };

  return (
    <MenuItem
      onClick={() => {
        onClick();
      }}
    >
      {intl.formatMessage({ id: "app.circles.assignAdminMenuItemText" })}
    </MenuItem>
  );
};
